import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import Layout from './layout/Layout';
import RoutesPaths from './router/RoutesPaths';

const App = () => {
  return (
    <>
      <Layout>
          <RoutesPaths />
      </Layout>
    </>
  )
}

export default App;
